import { Box, Button, styled } from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const loginQrcode = {
  container: styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    padding: '14.5px 20px',
    display: 'flex',
    borderRadius: '8px',
  })),
  counterContainer: styled(Box)(() => ({
    width: 'calc(100% - 180px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  })),
  refreshButton: styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.grey[300],
    width: 'fit-content',
    fontWeight: '700',
    fontSize: pxToRem(13),
    color: theme.palette.grey[800],
    display: 'flex',
    gap: '12px',
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
    },
  })),
};
